import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "subscribe"
}
const _hoisted_2 = {
  key: 1,
  class: "subscribe"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_AccountSetting = _resolveComponent("AccountSetting")!
  const _component_BaseSection = _resolveComponent("BaseSection")!

  return (_openBlock(), _createBlock(_component_BaseSection, null, {
    default: _withCtx(() => [
      _cache[6] || (_cache[6] = _createElementVNode("h3", null, "Marketing preferences", -1)),
      _createVNode(_component_AccountSetting, { icon: "account/mail" }, {
        default: _withCtx(() => [
          (!_ctx.isSubscribed)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[3] || (_cache[3] = _createElementVNode("p", null, "Subscribe to our newsletter", -1)),
                _createVNode(_component_BaseButton, {
                  loading: _ctx.loading,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateSubscription(true)))
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode("Subscribe")
                  ])),
                  _: 1,
                  __: [2]
                }, 8, ["loading"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _cache[5] || (_cache[5] = _createElementVNode("p", null, "You are currently subscribed to our newsletter", -1)),
                _createVNode(_component_BaseButton, {
                  loading: _ctx.loading,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateSubscription(false))),
                  class: "button--white"
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode("Unsubscribe")
                  ])),
                  _: 1,
                  __: [4]
                }, 8, ["loading"])
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1,
    __: [6]
  }))
}